const Favorites = () => {
  return (
    <div className="content-page-admin">
      <div className="title-page-admin">
        <i className="bx bx-heart"></i>
        <p>Favorites page</p>
      </div>
    </div>
  );
};

export default Favorites;
